{
  "tabs": {
    "label": "支払いの画面",
    "methods": "支払い方法",
    "reconciliation": "カード端末の明細",
    "refunds": "返金"
  },
  "page": {
    "intro": "お客様がWebと店頭でどう払えるかの設定です。カード端末の手数料はこの設定からシステムが計算します。",
    "load_failed": "支払いの設定を読み込めませんでした。",
    "read_only": "この設定は見るだけです。変更できるのはオーナーだけです。",
    "add_title": "まだ設定していません",
    "add": "{{name}}を追加"
  },
  "state": {
    "on": "オン",
    "off": "オフ"
  },
  "channels": {
    "web": "Webサイト",
    "web_desc": "お客様が注文時に選べます。",
    "pos": "店頭レジ",
    "pos_desc": "スタッフがレジで受け付けます。"
  },
  "save": "保存",
  "saved": "{{name}}を保存しました。",
  "confirm_title": "{{name}}を保存しますか？",
  "confirm_consequence": "お客様とレジはすぐに新しい設定を使います。変更は履歴（誰が・いつ・前と後）に残ります。",
  "pos_empty": "レジには少なくとも1つの支払い方法が必要です。先に別の方法をオンにしてください。",
  "warnings": {
    "needs_review": "見本の値です。実際の契約と照らし合わせてください。",
    "provider_phase_2": "この支払い方法は後で使えるようになり、それまではオフです。",
    "bank_account_missing": "まだ振込で払えません。お店の口座を入力してください。",
    "translations_missing": "文章のない言語があります。お客様には英語が表示されます。",
    "fee_percent_high": "カード手数料が5%を超えています。もう一度確認してください。",
    "pickup_location_missing": "受取できる店舗がないため、店頭払いを選べません。",
    "pickup_location_unverified": "今は受取店舗を確認できませんでした。"
  },
  "bank": {
    "title": "銀行振込",
    "desc": "今のWebのメインの支払い方法です。入金はスタッフが確認します。",
    "account": "お店の口座",
    "bank_name": "銀行名",
    "bank_code": "銀行コード（4桁）",
    "bank_name_en": "銀行名（英語）",
    "branch_name": "支店名",
    "branch_code": "支店コード（3桁）",
    "branch_name_en": "支店名（英語）",
    "account_type": "口座の種類",
    "futsu": "普通",
    "toza": "当座",
    "account_number": "口座番号（7桁）",
    "account_name": "口座名義（カナ）",
    "account_name_help": "銀行の表記どおり、カタカナで。",
    "problem_required": "{{field}}を入力してください。",
    "problem_format": "{{field}}の形式が正しくありません。",
    "fix_account": "赤い印の口座の欄を確認してください。",
    "instructions": "お客様に表示する文章",
    "instructions_field": "支払い方法の説明",
    "instructions_hint": "注文ページ・メール・追跡ページに表示します。英語と日本語は必須で、他の言語がないときは英語を表示します。",
    "missing_locale": "{{language}}がまだありません（英語を使用）",
    "text_en_ja": "英語と日本語で文章を書いてください。",
    "days": "支払い期限（日）",
    "days_help": "それまでカードはお客様のために確保されます。",
    "days_hint": "1〜14日（通常3日）。",
    "days_range": "1〜14日で選んでください。",
    "singles": "シングルカードも銀行振込で支払える",
    "singles_on": "オン：どのカードも銀行振込で支払えます（入金まで取り置きします）。",
    "singles_off": "オフ：カートにシングルカードがあると銀行振込は表示されません。未開封商品は銀行振込で支払えます。",
    "singles_help": "入金を待つ間、シングルカードはお客様のために取り置かれます。1点ものを長く取り置きたくない場合はオフにしてください。",
    "singles_none_left": "シングルカードを配送で買いたいお客様は、オンラインで支払う方法がなくなります（店頭受取だけになります）。シングルカードを配送で売り続けるなら、先に配送で使える別の支払い方法をオンにしてください。"
  },
  "locale": {
    "en": "英語",
    "ja": "日本語",
    "th": "タイ語",
    "zh-Hant": "中国語（繁体字）",
    "zh-Hans": "中国語（簡体字）"
  },
  "simple": {
    "cash": {
      "title": "現金",
      "desc": "店頭レジで。"
    },
    "pay_in_store": {
      "title": "店頭払い",
      "desc": "Webで注文し、受け取りのときに払います。"
    },
    "pickup_days": "受け取りを待つ日数",
    "pickup_days_help": "過ぎると注文は取り消され、カードは販売に戻ります。",
    "days_range": "1〜30日で選んでください。"
  },
  "store_credit": {
    "title": "ストアクレジット",
    "desc": "お店がお客様に渡したクレジット（返品・買取）。",
    "months": "有効期間",
    "months_help": "6か月を超えるクレジットは資金決済法の前払式支払手段になります（報告・供託が必要）。",
    "month_option_other": "{{count}}か月",
    "max": "最長",
    "law": "資金決済法 — お店は6か月以内にします。"
  },
  "edc": {
    "title": "カード端末（EDC）",
    "intro": "店頭のカード決済端末です。カード売上ごとの手数料はこの値から計算します。",
    "add": "端末を追加",
    "add_title": "カード端末を追加",
    "edit": "手数料を変更",
    "edit_title": "カード端末 {{name}}",
    "dialog_desc": "端末の契約どおりの手数料です。",
    "card_desc": "店頭のカード端末",
    "none": "まだカード端末はありません。",
    "needs_review": "見本の手数料を確認",
    "name": "端末の名前",
    "name_placeholder": "端末1",
    "name_required": "端末に名前をつけてください。",
    "company": "カード会社",
    "company_help": "端末契約の会社（お店用 — お客様には表示しません）。",
    "fee_percent": "手数料（%）",
    "fee_percent_help": "契約の通常の%です。ブランドごとの%は下で設定できます。",
    "fee_fixed": "1回ごとの固定手数料",
    "fee_fixed_help": "1回の支払いごとに固定の金額を加える契約もあります。",
    "percent_format": "%は3.24のように書いてください。",
    "percent_max": "最大10%です。",
    "percent_high": "5%を超えています。もう一度確認してください。",
    "fix_percent": "赤い印の%の欄を確認してください。",
    "brands": "カードブランドごとの手数料",
    "brands_hint": "空 = 端末の通常の%。端末で使えないブランドはチェックを外します。",
    "brand_percent": "{{brand}}の手数料（%）",
    "more_brands": "他のブランド（銀聯・iD・QUICPay・交通系IC…）",
    "fewer_brands": "ブランドを減らす",
    "not_accepted": "使えない",
    "bearer": "手数料を負担するのは",
    "bearer_help": "お店、委託者（売上に応じて）、またはお客様。",
    "surcharge_warning": "カード手数料をお客様に上乗せすると、カードブランドの規約や端末の加盟店契約に違反するおそれがあります。まずカード会社に確認してください。",
    "surcharge_ack": "上乗せのルールを確認しました",
    "ack_required": "先に「上乗せのルールを確認しました」にチェックしてください。",
    "min_amount": "最低金額（任意）",
    "max_amount": "最高金額（任意）",
    "preview_after_percent": "%を入力すると例が表示されます。",
    "save": "保存",
    "confirm_add": "この端末を追加しますか？",
    "confirm_edit": "新しい手数料を保存しますか？",
    "confirm_consequence": "これからこの端末のすべてのカード払いにこの手数料を使います。変更は履歴に残ります。",
    "summary_default": "通常の手数料：{{percent}}%"
  },
  "bearer": {
    "shop": "お店",
    "shop_desc": "手数料はすべてお店が払います。",
    "consignor_pro_rata": "委託者（按分）",
    "consignor_pro_rata_desc": "委託者が自分のカードの分の手数料を払います。",
    "customer_surcharge": "お客様",
    "customer_surcharge_desc": "お客様の支払いに上乗せ — 先にルールを確認。"
  },
  "bearer_short": {
    "shop": "お店が負担",
    "consignor_pro_rata": "委託者が按分で負担",
    "customer_surcharge": "お客様が負担"
  },
  "brand": {
    "VISA": "Visa",
    "MASTER": "Mastercard",
    "JCB": "JCB",
    "AMEX": "American Express",
    "DINERS": "Diners Club",
    "DISCOVER": "Discover",
    "UNIONPAY": "銀聯（UnionPay）",
    "ID": "iD",
    "QUICPAY": "QUICPay",
    "SUICA_TRANSIT": "交通系IC（Suicaなど）",
    "PAYPAY_VIA_EDC": "PayPay（端末）",
    "OTHER": "その他"
  },
  "fee_preview": {
    "title": "例",
    "updating": "例を更新中",
    "amount": "金額",
    "brand": "カード",
    "fee": "手数料",
    "net": "お店の受取額"
  },
  "stripe": {
    "title": "オンラインのカード決済",
    "will_add": "カード決済の接続で追加される方法",
    "method": {
      "card": "カード",
      "apple_pay": "Apple Pay",
      "google_pay": "Google Pay",
      "konbini": "コンビニ",
      "paypay": "PayPay"
    }
  },
  "reconcile": {
    "title": "カード端末の明細",
    "intro": "カード端末の1か月分の明細をアップロードします。システムが記録したカード払いと1行ずつ照合し、違いを表示します。",
    "result_intro": "一致したもの、違うもの、やること。",
    "no_terminal": "まだカード端末がありません",
    "no_terminal_body": "先に「支払い方法」で端末を追加してください。",
    "terminal": "端末",
    "month": "月",
    "choose_file": "明細（CSV）を選ぶ",
    "file_required": "明細のファイルを選んでください。",
    "check": "明細を照合",
    "reading": "明細を読み込み中…",
    "choose_columns": "このファイルの列が見つかりませんでした。下で一度選ぶと端末が覚えます。",
    "columns": "どの列が何か",
    "columns_hint": "日付と金額は必須です。多く選ぶほど正確に照合できます。",
    "columns_required": "日付と金額の列を選んでください。",
    "not_in_file": "ファイルにない",
    "field": {
      "date": "日付",
      "amount": "金額",
      "approvalCode": "承認番号",
      "last4": "カード番号下4桁",
      "brand": "カードブランド",
      "fee": "手数料",
      "time": "時刻",
      "kind": "売上・取消"
    },
    "duplicate": "この明細はすでに照合済みです。",
    "open_existing": "開く",
    "history": "照合した明細",
    "batch_status": {
      "uploaded": "受付",
      "parsing": "読み込み中",
      "open": "確認することあり",
      "reconciled": "すべて一致",
      "failed": "読めませんでした"
    },
    "export": "ダウンロード（CSV）",
    "another": "別の明細を照合",
    "statement_gross": "明細の売上",
    "expected_gross": "システムのカード売上",
    "statement_fee": "明細の手数料",
    "expected_fee": "システムの予定手数料",
    "fee_difference": "差：",
    "groups": "行",
    "group": {
      "matched": "一致",
      "variance": "手数料が違う",
      "unmatched": "システムにない",
      "missing_in_statement": "明細にない",
      "ignored": "確認済"
    },
    "group_help": {
      "matched": "明細の行と記録した支払いが一致しています。",
      "variance": "支払いは見つかりましたが、手数料が違います。",
      "unmatched": "端末にはあるがシステムにない — 手動で紐付けるか確認済にします。",
      "missing_in_statement": "システムにはあるが明細にない — カード会社に確認してください。",
      "ignored": "確認済にした行（理由のメモ付き）。"
    },
    "group_empty": "ありません。",
    "line": "行",
    "date": "日付",
    "amount": "金額",
    "card": "カード",
    "fee": "手数料",
    "expected": "予定手数料",
    "difference": "差",
    "order": "注文",
    "what": "状態",
    "match": "紐付け",
    "match_title": "{{line}}行目を紐付け",
    "match_desc": "この行のカード払いを選んでください。同じ金額が先に表示されます。",
    "no_candidates": "この期間にこの端末のカード払いはありません。",
    "matched": "紐付けました。",
    "ignore": "確認済にする",
    "ignore_title": "{{line}}行目は問題なし",
    "note": "理由",
    "note_hint": "例：同じ日に端末で取消した。",
    "ignored": "確認済にしました。",
    "fees_title": "カードブランドごとの手数料",
    "fees_intro": "保存した%からシステムが計算した予定額です。",
    "brand": "ブランド",
    "count": "件数",
    "fee_suggest_other": "{{brand}}：カード会社は{{count}}件で{{percent}}%を請求しました。",
    "fee_use": "今後は{{percent}}%を使う",
    "fee_confirm_title": "手数料を変更しますか？",
    "fee_confirm": "この端末の{{brand}}は今後{{percent}}%を使います。記録済みの支払いの手数料は変わりません。",
    "fee_confirm_button": "手数料を変更",
    "fee_set": "{{brand}}は{{percent}}%になりました。"
  },
  "refunds": {
    "title": "返金",
    "intro": "すべての注文の返金：金額、返し方、今の状態。",
    "order": "注文",
    "amount": "金額",
    "method": "方法",
    "reason": "理由",
    "status": "状態",
    "who": "依頼者",
    "approved_by": "承認：{{name}}",
    "date": "日付",
    "invoice": "返還インボイス",
    "invoice_open": "注文の書類",
    "view_open": "未完了",
    "view_done": "完了",
    "empty": "返金はありません。"
  },
  "refund_method": {
    "original": "支払いと同じ方法",
    "cash": "現金",
    "bank_transfer": "銀行振込",
    "store_credit": "ストアクレジット",
    "edc_manual": "カード端末"
  },
  "refund_reason": {
    "order_cancelled": "注文取消",
    "return": "返品",
    "overpayment": "払いすぎ",
    "price_adjustment": "価格の訂正",
    "goodwill": "サービス",
    "tax_free_refund": "免税の還付",
    "other": "その他"
  },
  "refund_status": {
    "requested": "依頼",
    "pending_approval": "承認待ち",
    "approved": "承認済",
    "processing": "処理中",
    "completed": "完了",
    "failed": "失敗",
    "rejected": "却下"
  },
  "refund_next": {
    "waiting_approval": "別の人の承認が必要",
    "hand_cash": "現金を返す",
    "enter_terminal_reference": "端末の取消番号を入力",
    "waiting_destination": "お客様の口座情報待ち",
    "transfer_money": "振込を送る",
    "failed": "もう一度試す"
  }
}
